import React, { useEffect, useRef, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { getAlert } from "../Services/appAlerts";
import { useDispatch, useSelector } from "react-redux";
import { appDocumentUploaded, getAppDocUploadSasUrl, getAppDocUploadStatus, uploadAppDocuments } from "../app/store/documents";
import { getCurrentUser } from "../app/store/auth";
import { uploadFileToBlob } from "../Services/blobUploadService";

const UploadDocPopup = (props) => {
  const { uploadDocShowHide, handleUploadDocModalShowHide,
    selectedDocType, runningApplication, messageAlert, contactDoc = "" } = props;

  const [documents, setDocuments] = useState([]);
  const [notes, setNotes] = useState("");
  const [btnProcess, setBtnProcess] = useState(false);
  const [isDragging, setIsDragging] = useState(false);

  const appDocUploadStatusSelector = useSelector(getAppDocUploadStatus);
  const appDocUploadSasUrlSelector = useSelector(getAppDocUploadSasUrl);

  const dispatch = useDispatch();
  const currentUser = getCurrentUser();
  const fileInputRef = useRef(null);

  useEffect(() => {
    if (!uploadDocShowHide) {
      setDocuments([]);
      setNotes("");
    }
  }, [uploadDocShowHide]);

  const doSubmit = () => {
    if (documents.length > 0) {
      setBtnProcess(true);
      let usrId = currentUser.id;
      if (currentUser.linkUser)
        usrId = currentUser.linkUser;
      const frmData = new FormData();
      frmData.append("message", notes);
      frmData.append("workflowTask", JSON.stringify(runningApplication[0]));
      frmData.append("userId", usrId);
      frmData.append("docType", !selectedDocType ? "" : selectedDocType);
      // documents.forEach((file, key) =>
      //   frmData.append(`files[${key}]`, file.file)
      // );
      frmData.append("files", JSON.stringify(documents.map((file) => ({
        name: file.name,
        type: file.type,
        size: file.size,
      }))));
      dispatch(uploadAppDocuments(frmData));
    } else {
      getAlert("", "Document not found", "error");
    }
  };

  useEffect(() => {
    if (appDocUploadStatusSelector > 0) {
      setBtnProcess(false);
      if (messageAlert && messageAlert !== "") {
        getAlert("", messageAlert, "success");
      } else {
        getAlert("", `${contactDoc === "" ? "Sent Successfully" : contactDoc}`, "success");
      }
      dispatch(appDocumentUploaded(null));
      handleUploadDocModalShowHide("save", "");
    }
  }, [appDocUploadStatusSelector]);


  useEffect(() => {
    const uploadAllDocuments = async () => {
      if (appDocUploadSasUrlSelector && appDocUploadSasUrlSelector?.length > 0) {
        try {
          await Promise.all(
            documents.map((file, key) =>
              uploadFileToBlob(
                file.file,
                appDocUploadSasUrlSelector[key]?.uploadUrl,
                (progress) => {
                  console.log(`Upload progress: ${progress}%`);
                }
              )
            )
          );

          // Runs only after ALL uploads finish   
          console.log("All files uploaded successfully!");
          dispatch(appDocumentUploaded(null));
        } catch (error) {
          console.error("Upload failed:", error);
        }
      }
    };
    uploadAllDocuments();
  }, [appDocUploadSasUrlSelector]);

  const onFileChange = async (event) => {
    const docs = [...documents];
    for (const file of event.target.files) {
      var doc = {
        name: file.name,
        type: file.type,
        size: file.size,
        file: file,
      };
      docs.push(doc);
    }
    setDocuments(docs);
  };

  const handleFileRemove = (item) => {
    const updatedDocuments = documents.filter((doc) => doc !== item);
    setDocuments(updatedDocuments);
  };

  // Drag & Drop Handlers
  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    const files = Array.from(e.dataTransfer.files);
    const docs = files.map(file => ({
      name: file.name,
      type: file.type,
      size: file.size,
      file: file,
    }));
    setDocuments(prev => [...prev, ...docs]);
  };

  return (
    <Modal show={uploadDocShowHide} size="xl">
      <Modal.Header closeButton onHide={() => handleUploadDocModalShowHide("", "")}>
        <Modal.Title>Upload Document</Modal.Title>
      </Modal.Header>
      <Modal.Body className="border">
        <div className="row">
          {/* Drop Zone */}
          <div className="col-md-12">
            <div
              className={`drop-zone w-100 p-4 mb-3 text-center border rounded ${isDragging ? "bg-light" : ""}`}
              onDragOver={handleDragOver}
              onDragLeave={handleDragLeave}
              onDrop={handleDrop}
              onClick={() => fileInputRef.current.click()}
              style={{
                border: "2px dotted #ccc",
                borderRadius: "8px",
                padding: "30px",
                textAlign: "center",
                background: isDragging ? "#f0f8ff" : "#fafafa",
                cursor: "pointer",
                transition: "background 0.2s ease",
              }}
            >
              <i className="fa fa-cloud-upload fa-2x mb-2"></i>
              <p className="mb-0">
                {isDragging ? "Drop files here..." : "Drag & drop files here, or click to select"}
              </p>
            </div>
          </div>

          {/* File Previews */}
          {documents.length > 0 && (
            <div className="file-preview w-100 mb-3">
              {documents.map((file, index) => (
                <div key={index} className="file-preview-item ml-3 d-flex align-items-center">
                  <span>{file.name}</span>
                  <span
                    className="file-size"
                    style={{
                      backgroundColor: "#f0f0f0",
                      marginLeft: "10px",
                      padding: "2px 5px",
                      borderRadius: "5px",
                    }}
                  >
                    {file.size} KB
                  </span>
                  <button
                    className="btn btn-sm btn-link"
                    onClick={() => handleFileRemove(file)}
                  >
                    <i className="fa fa-times text-black" ></i>
                  </button>
                </div>
              ))}
            </div>
          )}

          {/* Message Box */}
          <div className="col-md-12">
            <div className="form-group">
              <label htmlFor="message" className="form-control-label">
                Message
              </label>
              <textarea
                name="message"
                id="message"
                cols="2"
                rows="2"
                className="form-control"
                value={notes}
                onChange={({ currentTarget }) => setNotes(currentTarget.value)}
              ></textarea>
            </div>
          </div>

          {/* Buttons */}
          <div className="col-12 text-center mt-3 d-flex justify-content-center">
            {/* <Button variant="outline-dark" size="sm" onClick={() => fileInputRef.current.click()}>
              <i className="fa fa-paperclip mr-2" ></i>
              Add
            </Button> */}
            <Button variant="outline-dark" size="sm" onClick={doSubmit} disabled={btnProcess || documents.length === 0} className="ml-2">
              <i className="fa fa-paper-plane-o mr-2" ></i>
              Send
            </Button>
          </div>

          <input
            type="file"
            ref={fileInputRef}
            onChange={onFileChange}
            aria-label="Upload files"
            multiple
            style={{ display: "none" }}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default UploadDocPopup;
